<div class="container">
    <div class="single-column-layout">
        <h1>API Keys</h1>
        <span class="anchor-style" (click)="backToManage()">Back to list</span>
        <div [style.display]="loading ? 'block' : 'none'" class="text-center" style="margin-top: 50px;">
            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
        </div>
        @if (!loading) {
            <div style="margin-top: 1em;" class="manage-api-key-detail">
                <div class="card panel-flat-color primary-panel" [ngClass]="(inEditMode) ? 'edit-mode' : 'view-mode'">
                    <div class="panel-flat-header">
                        <div class="header-icon float-start">
                            <i class="fa fa-info fa-fw"></i>
                        </div>
                        <h3>API Key</h3>
                        <div class="float-end header-button-container">
                            @if (!inEditMode) {
                                <button (click)="edit_click()"
                                        type="button"
                                        class="ace-btn has-icon btn-primary btn-text">
                                    <i class="fa fa-pencil"></i>
                                </button>
                            }
                            @if (inEditMode) {
                                <span>
                                    <button (click)="save_click()"
                                            type="button"
                                            class="ace-btn has-icon btn-primary btn-success btn-text">
                                        <i class="fa fa-save"></i>
                                    </button>
                                    <button (click)="cancel_click()"
                                            type="button"
                                            class="ace-btn has-icon btn-primary btn-danger btn-text">
                                        <i class="fa fa-close"></i>
                                    </button>
                                </span>
                            }
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <div class="panel-flat-body">
                        <label>
                            <span class="title">Active:</span>
                            @if (integrationHmacDetail.isActive) {
                                <span class="view-control">Yes</span>
                            }
                            @if (!integrationHmacDetail.isActive) {
                                <span class="view-control">No</span>
                            }
                            <input type="checkbox" [(ngModel)]="integrationHmacDetail.isActive" class="edit-control"/>
                        </label>
                        <label>
                            <span class="title">Name:</span>
                            <span class="view-control">{{ integrationHmacDetail.name }}</span>
                            <input type="text" [(ngModel)]="integrationHmacDetail.name" class="edit-control"/>
                            @if (keyNameValidationMessage) {
                                <span class="validation-error">{{ keyNameValidationMessage }}</span>
                            }
                        </label>
                        <label>
                            <span class="title">Public Key:</span>
                            <span class="both-control">{{ integrationHmacDetail.publicKey }}</span>
                        </label>
                        <label>
                            <span class="title">Company:</span>
                            <span class="both-control">{{ integrationHmacDetail.companyName }}</span>
                        </label>
                        <div>
                            <h3>Users:</h3>
                            <table class="user-table">
                                <tbody>
                                    @for (user of integrationHmacDetail.users; track user.integratonHmacUserId) {
                                        <tr>
                                            <td>{{ user.lastName }}, {{ user.firstName }}</td>
                                            <td>
                                                <button (click)="sendEmail(user)"
                                                        type="button"
                                                        class="view-control ace-btn btn-primary btn-sm">
                                                    Send Private Key Email
                                                </button>
                                                <button (click)="removeUser(user)"
                                                        type="button"
                                                        class="edit-control ace-btn has-icon btn-primary btn-danger">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                            <div>
                                @if (!addingUser) {
                                    <button (click)="beginAddUser_click()" class="edit-control ace-btn btn-primary">Add
                                        User
                                    </button>
                                }
                                <div [style.display]="addingUser ? 'inline-block' : 'none'">
                                    <div style="display:inline-block; width: 15em;">
                                        <user-team-picker [user]="newUser"
                                                          (userChange)="setNewUser($event)"></user-team-picker>
                                    </div>
                                    <button (click)="saveAddUser_click()"
                                            type="button"
                                            class="ace-btn has-icon btn-primary btn-success">
                                        <i class="fa fa-save"></i>
                                    </button>
                                    <button (click)="cancelAddUser_click()"
                                            type="button"
                                            class="ace-btn has-icon btn-primary btn-danger">
                                        <i class="fa fa-close"></i>
                                    </button>
                                </div>
                                <button (click)="deleteKey_click()"
                                        class="edit-control ace-btn btn-primary btn-danger"
                                        style="float:right;">
                                    Delete Key
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
